var OTT = OTT || {};
OTT.ChooseOfferForm = (function ($, OTT) {
  var Form;

  Form = function (config) {
    this.config = config;
    this.formRendered = false;

    this.receiveMessage = this.receiveMessage.bind(this);

    this.$container = $(this.config.containerSelector).first();
    this.$iframe = null;
    window.addEventListener("message", this.receiveMessage, false);

    this.renderForm();
  };

  Form.prototype.renderForm = function () {
    var url;

    if (this.$container.length === 0) {
      console.log("Container for choose offer form missing");
      return;
    }

    url = new URL(this.config.baseUrl + "/signup?" + this.config.embedOptions);
    url.searchParams.append("step", 1);
    url.searchParams.append("embed", 1);

    // Render the iframe
    this.$container.html(
      '<iframe class="ott-registration-choose-offer-form" src="' +
        url.toString() +
        '"></iframe>'
    );
    this.$iframe = this.$container.find("iframe");
  };

  Form.prototype.teardownForm = function () {
    this.$container.empty();
  };

  Form.prototype.receiveMessage = function (event) {
    if (
      event.origin !== new URL(this.config.baseUrl).origin ||
      event.source !== this.$iframe[0].contentWindow
    ) {
      return;
    }

    // Scale the iframe
    if (event.data.type === "ResponsiveIframe::resized") {
      this.$iframe && this.$iframe.css("height", event.data.data.height + "px");
    }

    // Execute a redirect
    else if (event.data.type === "ChooseOffer::requestRedirect") {
      window.location = event.data.data.url;
    }
  };

  Form.prototype.destroy = function () {
    document.removeEventListener(
      "CookieConsent::changed",
      this.onCookieConsentChanged
    );
    window.removeEventListener("message", this.receiveMessage, false);
    this.formRendered && this.teardownForm();
  };

  return Form;
})(jQuery, OTT);
